import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Subheader.scss';

const Subheader = props => (
  <div className={`subheader ${props.className || ''}`}>
    {props.children}
  </div>
);

export default Subheader;
